module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [(_vm.isReadOnly && _vm.dataValid && _vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (props.rec.contract_status_id === 2) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 1)
            }
          }
        }, [_vm._v("Accept Offer")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 1 || props.rec.contract_status_id === 3) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 2)
            }
          }
        }, [_vm._v("Reject Offer")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 1 || props.rec.contract_status_id === 2 || props.rec.contract_status_id === 4 || props.rec.contract_status_id === 6) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 3)
            }
          }
        }, [_vm._v("Enrole")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 3) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 4)
            }
          }
        }, [_vm._v("Take a break")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id === 3) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 5)
            }
          }
        }, [_vm._v("Graduate")]) : _vm._e(), _vm._v(" "), (props.rec.contract_status_id > 2 && props.rec.contract_status_id < 6) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.changeState(props.rec, 6)
            }
          }
        }, [_vm._v("Drop-out")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalExportPaymentStatus.show()
            }
          }
        }, [_vm._v("Download PF Payment Status")]), _vm._v(" "), (false) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.checkSwitchToSemesterPayment(props.rec)
            }
          }
        }, [_vm._v("Switch to semester payment")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.requestPaymentInfo(props.rec)
            }
          }
        }, [_vm._v("Request payment info for refund")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.downloadInvoiceDetails(props.rec)
            }
          }
        }, [_vm._v("Download Numbered Invoice Details")])], 2) : _vm._e(), _vm._v(" "), (props.rec.student_id) ? _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'student',
                params: {
                  id: props.rec.student_id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Student\n      ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('planned_invoices', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Planned Invoices\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('numbered_invoices', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Numbered Invoices\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('creditnote_invoices', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Credit Notes\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('invoicepayments', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Invoice Payments\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('planned_scholarshippayments', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Planned Payments\n      ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "default",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.gotoOverviewWithFilter('numbered_scholarshippayments', {
                contract_id: props.rec.id
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-right"
        }), _vm._v(" Numbered Payments\n      ")])]
      }
    }, {
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-tabs', {
          ref: "tabs",
          attrs: {
            "small": "",
            "card": ""
          },
          model: {
            value: (_vm.tabIndex),
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        }, [_c('b-tab', {
          attrs: {
            "title": "General"
          }
        }, [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-0",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Student",
            "field": "student_id",
            "optionListApiUrl": '/students/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Application Number",
            "field": "application_number",
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Intake",
            "field": "intake",
            "optionListApiUrl": '/contracts_intake/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Round",
            "field": "application_round",
            "optionList": ['0', '1', '2', '3', '4', '5'],
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Application ID",
            "field": "application_id",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Scholarship",
            "field": "scholarship_id",
            "optionListApiUrl": '/scholarships/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Status",
            "field": "contract_status_id",
            "optionListApiUrl": '/contract_status/choice/',
            "rec": props.rec,
            "isReadOnly": true,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Status Date",
            "field": "contract_status_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Program",
            "field": "program_id",
            "optionListApiUrl": '/programs/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "DA Application ID",
            "field": "da_application_id",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "DA Offer Status",
            "field": "da_offer_type",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "University Y1",
            "field": "y1_university_id",
            "optionListApiUrl": '/universities/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Y1 Finished",
            "field": "year1_finished",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Active",
            "field": "active",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "University Y2",
            "field": "y2_university_id",
            "optionListApiUrl": '/universities/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Y2 Finished",
            "field": "year2_finished",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "Start Date",
            "field": "start_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          },
          on: {
            "input": function($event) {
              _vm.onStartDateInput(props.rec, $event)
            }
          }
        }), _vm._v(" "), _c('detail-field', {
          ref: "enddate",
          staticClass: "col-md-4 field-right-border",
          attrs: {
            "label": "End Date",
            "field": "end_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Expected Graduation Date",
            "field": "expected_graduation_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [(!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Bank Info Required",
            "field": "bankinfo_required",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Check University Fee Payment",
            "field": "check_universityfee_payment",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Instalments",
            "field": "instalments",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "boolean",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Contract Sent",
            "field": "contract_sent_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Contract Signed",
            "field": "contract_signed_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-4",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoiced Amount",
            "field": "invoiced_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Paid Amount",
            "field": "payed_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "To Be Paid Amount",
            "field": "to_be_payed_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Planned Amount",
            "field": "planned_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('b-tab', {
          attrs: {
            "title": 'Documents (' + ((_vm.dataValid && props.rec.files) ? props.rec.files.length : 0) + ')'
          }
        }, [(_vm.dataValid && props.rec.files) ? _c('div', _vm._l((props.rec.files), function(doc, index) {
          return _c('b-card', {
            key: doc.id,
            staticClass: "template-card"
          }, [_vm._v("\n                " + _vm._s(doc.filename)), _c('br'), _vm._v("\n                " + _vm._s(doc.description)), _c('br'), _vm._v(" "), _c('b-button', {
            on: {
              "click": function($event) {
                _vm.downloadDocument(doc)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-download"
          }), _vm._v(" Download")]), _vm._v(" "), (_vm.privUser) ? _c('b-button', {
            directives: [{
              name: "b-modal",
              rawName: "v-b-modal.modalDocDeleteOk",
              modifiers: {
                "modalDocDeleteOk": true
              }
            }],
            on: {
              "click": function($event) {
                _vm.activeDocument = doc
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          }), _vm._v(" Delete")]) : _vm._e()], 1)
        })) : _vm._e(), _vm._v(" "), (_vm.privUser) ? _c('b-card', [_c('b-form-file', {
          ref: "fileinput",
          attrs: {
            "placeholder": " "
          },
          model: {
            value: (_vm.documentToUpload),
            callback: function($$v) {
              _vm.documentToUpload = $$v
            },
            expression: "documentToUpload"
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "File Type",
            "field": "ft_id",
            "optionListApiUrl": '/file_types/choice/',
            "rec": _vm.fileRec,
            "isReadOnly": false,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Description",
            "field": "description",
            "rec": _vm.fileRec,
            "isReadOnly": false,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('b-button', {
          attrs: {
            "disabled": !_vm.documentToUpload
          },
          on: {
            "click": function($event) {
              _vm.uploadDocument(props.rec.id, _vm.documentToUpload)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        }), _vm._v(" Upload")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
          attrs: {
            "id": "modalDocDeleteOk",
            "title": "Delete Document",
            "ok-title": "Yes",
            "close-title": "No"
          },
          on: {
            "ok": _vm.deleteDocument
          }
        }, [_vm._v("\n      Are you sure you want to delete this document?\n    ")]), _vm._v(" "), _c('b-modal', {
          ref: "modalSwitchSemesterPaymentOk",
          attrs: {
            "title": "Switch to Semester Payment",
            "ok-title": "Yes",
            "close-title": "No"
          },
          on: {
            "ok": _vm.doSwitchToSemesterPayment
          }
        }, [_vm._v("\n      Are you sure to switch to semester payment?\n    ")]), _vm._v(" "), _c('b-modal', {
          ref: "modalExportPaymentStatus",
          attrs: {
            "size": "lg",
            "title": "Download PF Payment Status",
            "ok-title": "Download",
            "close-title": "Cancel",
            "ok-disabled": false
          },
          on: {
            "ok": function($event) {
              _vm.downloadPaymentStatus(props.rec)
            }
          }
        }, [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Simulation date for testing",
            "type": "date",
            "field": "simulation_date",
            "rec": _vm.downloadPaymentRec,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e26e8562"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contract/Detail.vue
// module id = 721
// module chunks = 1